var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.18945 5.83008L0.205078 1.8457C0.0683594 1.70898 0 1.54297 0 1.34766C0 1.15234 0.0683594 0.986328 0.205078 0.849609L0.878906 0.205078C1.01562 0.0683594 1.18164 0 1.37695 0C1.57227 0 1.73828 0.0683594 1.875 0.205078L4.6875 3.01758L7.5 0.205078C7.63672 0.0683594 7.80273 0 7.99805 0C8.19336 0 8.35938 0.0683594 8.49609 0.205078L9.16992 0.849609C9.30664 0.986328 9.375 1.15234 9.375 1.34766C9.375 1.54297 9.30664 1.70898 9.16992 1.8457L5.18555 5.83008C5.04883 5.9668 4.88281 6.03516 4.6875 6.03516C4.49219 6.03516 4.32617 5.9668 4.18945 5.83008Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.6abe840b.svg";
export { ForwardRef as ReactComponent };